const EmailTemplates = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-id="treeNode_emailtemplates_27AssetIcon"
    className="spectrum-Icon_368b34 spectrum-Icon--sizeS_368b34 TreeIconWrapper spectrum-Icon_e2d99e"
    focusable="false"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    fill={'rgb(105, 123, 144)'}
  >
    <defs>
      <symbol id="icon-meue-email-template" viewBox="0 0 20 20">
        <path d="M19.444 2.222H.556A.556.556 0 000 2.778v14.444a.556.556 0 00.556.556h18.888a.556.556 0 00.556-.556V2.778a.556.556 0 00-.556-.556zm-.556 1.111v.837L10 10.967l-8.889-6.8v-.834zm0 2.235v8.833l-5.777-4.416zm-12 4.417l-5.777 4.416V5.568zm-5.777 6.681v-.867L7.8 10.684l1.524 1.167a1.111 1.111 0 001.35 0l1.526-1.167 6.69 5.116v.867z"></path>
      </symbol>
    </defs>
    <use xlinkHref="#icon-meue-email-template" fill="#697B90"></use>
  </svg>
);

export default EmailTemplates;
